import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Header from "../components/Header";
import { redefinirSenha } from "../services/api";

export default function RedefinirSenhaPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [nova, setNova] = useState("");
  const [conf, setConf] = useState("");
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState(null);
  const [ok, setOk] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    setErro(null);
    if (nova.length < 6) { setErro("A nova senha deve ter ao menos 6 caracteres."); return; }
    if (nova !== conf) { setErro("A confirmação não confere com a nova senha."); return; }
    setCarregando(true);
    try {
      await redefinirSenha(token, nova);
      setOk(true);
      setTimeout(() => navigate("/entrar"), 2500);
    } catch (err) {
      setErro(err.message || "Não foi possível redefinir a senha.");
    } finally {
      setCarregando(false);
    }
  };

  const inputCls = "w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:ring-2 focus:ring-primary outline-none";

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-md mx-auto px-4 py-10">
        <div className="rounded-2xl border border-gray-200 bg-white p-6 shadow-sm">
          <h1 className="text-xl font-bold text-text">Redefinir senha</h1>

          {!token ? (
            <div className="mt-4">
              <p className="rounded-lg bg-red-50 border border-red-200 text-red-700 px-3 py-3 text-sm">
                Link inválido — falta o token. Solicite uma nova redefinição.
              </p>
              <Link to="/esqueci-senha" className="inline-block mt-4 text-sm text-primary font-semibold hover:underline">Pedir novo link</Link>
            </div>
          ) : ok ? (
            <div className="mt-4">
              <p className="rounded-lg bg-green-50 border border-green-200 text-green-800 px-3 py-3 text-sm">
                Senha redefinida com sucesso! Redirecionando para o login...
              </p>
              <Link to="/entrar" className="inline-block mt-4 text-sm text-primary font-semibold hover:underline">Ir para o login agora</Link>
            </div>
          ) : (
            <form onSubmit={enviar} className="mt-4 space-y-3">
              <p className="text-sm text-gray-600">Crie uma nova senha para a sua conta.</p>
              {erro && <p role="alert" className="rounded-lg bg-red-50 border border-red-200 text-red-700 px-3 py-2 text-sm">{erro}</p>}
              <input type="password" required className={inputCls} placeholder="Nova senha (mín. 6 caracteres)" aria-label="Nova senha (mín. 6 caracteres)" value={nova} onChange={(e) => setNova(e.target.value)} autoComplete="new-password" minLength={6} />
              <input type="password" required className={inputCls} placeholder="Confirmar nova senha" aria-label="Confirmar nova senha" value={conf} onChange={(e) => setConf(e.target.value)} autoComplete="new-password" />
              <button type="submit" disabled={carregando || !nova || !conf}
                className="w-full bg-primary hover:opacity-90 disabled:opacity-60 text-white font-bold py-2.5 rounded-lg">
                {carregando ? "Salvando..." : "Redefinir senha"}
              </button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
